var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-19.50855 -30.10175 169.0741 180.6105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.027 120.407c-4.651 0-7.042-3.033-7.042-3.033-3.823-.166-33.7-.083-33.7-.083l-2.908-24.552S2.975 79.77 1.48 78.273C-7.353 38.2 24.574 0 65.028 0c40.455 0 72.382 38.201 63.549 78.273-1.496 1.496-19.897 14.466-19.897 14.466l-2.91 24.552s-29.875-.083-33.698.083c0 0-2.391 3.033-7.045 3.033z",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.07 83.069l-2.823-70.87c-3.404-.695-12.09.139-16.744 3.613L59.05 83.347 40.57 18.59c-4.431-.054-13.371 7.437-14.036 9.658l26.959 57.46-30.294-52.527c-2.987 1.112-9.518 13.132-8.476 14.529L48.49 89.044 13.75 53.748s-4.516 6.879-1.571 18.53l19.623 14.17 2.457 19.36h24.058s3.936 3.732 6.729 3.732c2.792 0 6.728-3.731 6.728-3.731h24.059l2.457-19.36 19.622-14.171c2.946-11.651-1.57-18.53-1.57-18.53l-34.74 35.296 33.767-41.333c1.042-1.397-5.49-13.417-8.477-14.529L76.599 85.71l26.958-57.46c-.664-2.22-9.605-9.712-14.035-9.658L71.04 83.347l13.55-67.535c-4.655-3.474-13.34-4.308-16.745-3.613z",
    fill: "#ffd500"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShell);
export default __webpack_public_path__ + "static/media/shell.103b2e0cf4f3725156badcfa290d1210.svg";
export { ForwardRef as ReactComponent };